import { CircularProgress } from '@material-ui/core';
import React from 'react';

const AlphabetFilter = ({
  selectedLetters,
  onSelect,
  isLoading,
  glossary
}: any) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const filteredLetters = alphabet.filter(letter =>
    glossary.some((item: any) => item.term.charAt(0).toUpperCase() === letter)
  );

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <div style={{ margin: '1rem 0' }}>
          {alphabet.map(letter => {
            const isAvailable = filteredLetters.includes(letter);
            return (
              <span
                key={letter}
                onClick={isAvailable ? () => onSelect(letter) : undefined}
                style={{
                  cursor: isAvailable ? 'pointer' : 'not-allowed',
                  margin: '0 0.2rem',
                  padding: '0.3rem 0.5rem',
                  borderRadius: '4px',
                  backgroundColor:
                    selectedLetters.includes(letter) && isAvailable
                      ? '#ddd'
                      : '#fff',
                  color: isAvailable ? '#000' : '#aaa', // Grey out unused letters
                  opacity: isAvailable ? 1 : 0.5 // Fade out unused letters
                }}
              >
                {letter}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
};

export default AlphabetFilter;
